// 引导页背景
import { hexToRgba } from './utils'

const WHITE_COLOR = '#FFFFFF'
// const BLACK_COLOR = '#000000'
const BASE_URL = 'https://erphostjs.kye-erp.com/public/theme/'
const GUIDE_BG = '-bg.png'
const THEME_CARD_BG = '.png' // 小卡片背景
const THEME_HEADER_BG = '-header.png' // 头部背景

const THEME_MODE_KEYS = {
  LIGHT: 'light',
  DARK: 'dark',
  ATMOSPHERE: 'atmosphere',
}

// 主题模式颜色
const THEME_COLOR_KEYS = {
  // 浅色主题
  LIGHT_PURPLE_DEFAULT: 'light-purple-default',
  LIGHT_PURPLE: 'light-purple',
  LIGHT_BLUE: 'light-blue',
  LIGHT_ICE_BLUE: 'light-ice-blue',
  LINGT_GREEN: 'light-green',
  LIGHT_EYE_GREEN: 'light-eye-green',
  LIGHT_EYE_YELLOW: 'light-eye-yellow',
  LIGHT_PINK: 'light-pink',
  // 深色主题
  DARK_PURPLE: 'dark-purple',
  DARK_PURPLE_DEFAULT: 'dark-purple-default',
  DARK_ADZUKI_PURPLE: 'dark-adzuki-purple',
  DARK_BLUE: 'dark-blue',
  DARK_GREEN: 'dark-green',
  DARK_OLIVE_GREEN: 'dark-olive-green',
  DARK_BROWN: 'dark-brown',
  DARK_PINK: 'dark-pink',
  DARK_GRAY: 'dark-gray',

  // 氛围主题
  ATMOSPHERE_SPRING: 'atmosphere-spring',
  ATMOSPHERE_SUMMER: 'atmosphere-summer',
  ATMOSPHERE_AUTUMN: 'atmosphere-autumn',
  ATMOSPHERE_WINTER: 'atmosphere-winter',
  ATMOSPHERE_PURPLE: 'atmosphere-purple',
}

// 主题token
export const TOKENS = {
  // 主色
  COLOR: 'color',

  // 背景色
  // BG: 'bg',

  // 文字色
  COLOR_TEXT: 'color-text',
  PLACEHOLDER_COLOR: 'placeholder-color', // 正文 0.5
  PLACEHOLDER_DARK_COLOR: 'placeholder-dark-color', // 深色 白色 0.5


  // 分割线
  DIVIDER: 'divider', // 正文0.2

  // logo颜色
  LOGO_COLOR: 'logo-color', // 主色
  LOGO_GRAY_COLOR: 'logo-gray-color', // 灰度标识，主色

  // 侧边栏
  SIDEBAR_BG: 'sidebar-bg', // 侧边栏背景
  SIDEBAR_DIVIDER: 'sidebar-divider', // 主色 0.06 或者 白色0.06（深）
  SIDEBAR_COLOR_TEXT_LAST: 'sidebar-color-text-last', // 正文 0.8
  SIDEBAR_COLOR_TEXT_ACTIVE: 'sidebar-color-text-active', // 主色 或者 白色（深）
  SIDEBAR_ICON_COLOR: 'sidebar-icon-color', // 折叠/展开 正文 0.5
  SIDEBAR_BG_HOVER: 'sidebar-bg-hover', // 主色0.06
  SIDEBAR_BG_ACTIVE: 'sidebar-bg-active', // 主色0.1
  SIDEBAR_EXPAND_BG: 'sidebar-expand-bg', // 一二三级菜单展开背景 主色0.04
  SIDEBAR_COLLAPSE_BG_ACTIVE: 'sidebar-collapse-bg-active', // 主色 0.1
  SIDEBAR_COLLAPSE_BG_HOVER: 'sidebar-collapse-bg-hover', // 主色 0.06

  // 菜单TAB
  NAVBAR_COLOR_TEXT: 'navbar-color-text', // 正文 0.8
  NAVBAR_ICON_COLOR: 'navbar-icon-color', // 正文 0.8
  NAVBAR_ICON_COLOR_HOVER: 'navbar-icon-color-hover',
  NAVBAR_ICON_BG: 'navbar-icon-bg', // 主色 0.1
  NAVBAR_BG: 'navbar-bg', // 头部背景（纯颜色）
  NAVBAR_BG_HOVER: 'navbar-bg-hover', // 内容背景 0.6
  NAVBAR_BG_ACTIVE: 'navbar-bg-active', // 内容背景 0.6

  // 头部
  // HEADER_BG: 'header-bg', // 头部背景（纯颜色）
  HEADER_GRADIENT_BG: 'header-gradient-bg', // 渐变背景（纯颜色）
  HEADER_BG_IMAGE: 'header-bg-image', // 头部背景图片（组装好的渐变/图片字符串）
  HEADER_ACTION_TEXT: 'header-action-color-text', // 头部操作文字
  HEADER_ACTION_TEXT_HOVER: 'header-action-color-text-hover', // 头部操作文字悬停
  HEADER_ACTION_BG: 'header-action-bg', // 头部操作背景
  HEADER_ACTION_BG_HOVER: 'header-action-bg-hover', // 头部操作背景悬停

  // 搜索区域
  SEARCH_BG: 'search-bg', // 白色0.7
  SEARCH_BORDER: 'search-border', // 正文0.1或者白色0.1
  SEARCH_BORDER_FOCUS: 'search-border-focus', // 主色或者白色0.5

  // 内容区域
  CONTENT_BG: 'content-bg',

  // 常用模块
  MENU_ICON_BG_HOVER: 'menu-icon-bg-hover', // 主色 0.06
}

// 主题token前缀
export const THEME_PREFIX = '--g-theme-'

// 存储/全局事件key
export const THEME_KEY = 'GLOBAL_THEME_SYSTEM'

// 基本配置-浅色
// const LIGHT_PURPLE_DEFAULT = {
//   label: '默认',
//   value: THEME_COLOR_KEYS.LIGHT_PURPLE_DEFAULT,
//   url: BASE_URL + THEME_COLOR_KEYS.LIGHT_PURPLE_DEFAULT + THEME_CARD_BG, // 主题设置小方块背景图片
//   guideUrl: BASE_URL + THEME_COLOR_KEYS.LIGHT_PURPLE_DEFAULT + GUIDE_BG,
//   mode: THEME_MODE_KEYS.LIGHT,
//   [TOKENS.COLOR]: '#6D2EF8',
//   [TOKENS.COLOR_TEXT]: '#453C5A',
//   [TOKENS.HEADER_BG]: '#F2F5FF',
//   [TOKENS.HEADER_GRADIENT_BG]: '#E8EBFF',
//   [TOKENS.SIDEBAR_BG]: '#F2F5FF',
//   [TOKENS.CONTENT_BG]: '#EBEFFA',
//   [TOKENS.HEADER_BG_IMAGE]: '',
// }

const LIGHT_PURPLE = {
  label: '紫色',
  value: THEME_COLOR_KEYS.LIGHT_PURPLE,
  url: BASE_URL + THEME_COLOR_KEYS.LIGHT_PURPLE + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.LIGHT_PURPLE + GUIDE_BG,
  mode: THEME_MODE_KEYS.LIGHT,
  [TOKENS.COLOR]: '#6D2EF8',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#F3F2FE',
  [TOKENS.HEADER_GRADIENT_BG]: ['#E1DFFF', '#E1DFFF'],
  [TOKENS.SIDEBAR_BG]: '#FAF9FE',
  [TOKENS.CONTENT_BG]: '#FAF9FE',
  [TOKENS.HEADER_BG_IMAGE]: '',
  [TOKENS.HEADER_ACTION_TEXT]: '#393195',
  [TOKENS.NAVBAR_COLOR_TEXT]: '#393195',
}

const LIGHT_ICE_BLUE = {
  label: '冰淇淋蓝色',
  value: THEME_COLOR_KEYS.LIGHT_ICE_BLUE,
  url: BASE_URL + THEME_COLOR_KEYS.LIGHT_ICE_BLUE + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.LIGHT_ICE_BLUE + GUIDE_BG,
  mode: THEME_MODE_KEYS.LIGHT,
  [TOKENS.COLOR]: '#1E4BEC',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#BCE7FF',
  [TOKENS.HEADER_GRADIENT_BG]: ['#AFE2FF', '#AFE2FF'],
  [TOKENS.SIDEBAR_BG]: '#F7FCFF',
  [TOKENS.CONTENT_BG]: '#F7FCFF',
  [TOKENS.HEADER_BG_IMAGE]: '',
  [TOKENS.HEADER_ACTION_TEXT]: '#073F75',
  [TOKENS.NAVBAR_COLOR_TEXT]: '#073F75',
}
const LIGHT_BLUE = {
  label: '浅蓝色',
  value: THEME_COLOR_KEYS.LIGHT_BLUE,
  url: BASE_URL + THEME_COLOR_KEYS.LIGHT_BLUE + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.LIGHT_BLUE + GUIDE_BG,
  mode: THEME_MODE_KEYS.LIGHT,
  [TOKENS.COLOR]: '#236AF2',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#F1F7FE',
  [TOKENS.HEADER_GRADIENT_BG]: ['#DFEAFF', '#DFEAFF'],
  [TOKENS.SIDEBAR_BG]: '#FAFCFF',
  [TOKENS.CONTENT_BG]: '#FAFCFF',
  [TOKENS.HEADER_BG_IMAGE]: '',
  [TOKENS.HEADER_ACTION_TEXT]: '#002566',
  [TOKENS.NAVBAR_COLOR_TEXT]: '#002566',
}
// const LINGT_GREEN = {
//   label: '青绿色',
//   value: THEME_COLOR_KEYS.LINGT_GREEN,
//   url: BASE_URL + THEME_COLOR_KEYS.LINGT_GREEN + THEME_CARD_BG, // 主题设置小方块背景图片
//   guideUrl: BASE_URL + THEME_COLOR_KEYS.LINGT_GREEN + GUIDE_BG,
//   mode: THEME_MODE_KEYS.LIGHT,
//   [TOKENS.COLOR]: '#007E6F',
//   [TOKENS.COLOR_TEXT]: '#1D1C23',
//   [TOKENS.HEADER_BG]: '#BEE3DB',
//   [TOKENS.HEADER_GRADIENT_BG]: '#A8D6CA',
//   [TOKENS.SIDEBAR_BG]: '#BEE3DB',
//   [TOKENS.CONTENT_BG]: '#EDF9F7',
//   [TOKENS.HEADER_BG_IMAGE]: '',
// }
const LIGHT_EYE_GREEN = {
  label: '绿色',
  value: THEME_COLOR_KEYS.LIGHT_EYE_GREEN,
  // isEyeCare: true,
  url: BASE_URL + THEME_COLOR_KEYS.LIGHT_EYE_GREEN + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.LIGHT_EYE_GREEN + GUIDE_BG,
  mode: THEME_MODE_KEYS.LIGHT,
  [TOKENS.COLOR]: '#007E6F',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#F1F6EE',
  [TOKENS.HEADER_GRADIENT_BG]: ['#C5ECE3', '#C5ECE3'],
  [TOKENS.SIDEBAR_BG]: '#F2F7F5',
  [TOKENS.CONTENT_BG]: '#F2F7F5',
  [TOKENS.HEADER_BG_IMAGE]: '',
  [TOKENS.HEADER_ACTION_TEXT]: '#053d30',
  [TOKENS.NAVBAR_COLOR_TEXT]: '#053d30',
}
// const LIGHT_EYE_YELLOW = {
//   label: '黄色',
//   value: THEME_COLOR_KEYS.LIGHT_EYE_YELLOW,
//   isEyeCare: true,
//   url: BASE_URL + THEME_COLOR_KEYS.LIGHT_EYE_YELLOW + THEME_CARD_BG, // 主题设置小方块背景图片
//   guideUrl: BASE_URL + THEME_COLOR_KEYS.LIGHT_EYE_YELLOW + GUIDE_BG,
//   mode: THEME_MODE_KEYS.LIGHT,
//   [TOKENS.COLOR]: '#D97757',
//   [TOKENS.COLOR_TEXT]: '#1D1C23',
//   // [TOKENS.HEADER_BG]: '#F7F5F2',
//   [TOKENS.HEADER_GRADIENT_BG]: ['#F8E7D3', '#F8E7D3'],
//   [TOKENS.SIDEBAR_BG]: '#F7F5F2',
//   [TOKENS.CONTENT_BG]: '#F7F5F2',
//   [TOKENS.HEADER_BG_IMAGE]: '',
//   [TOKENS.HEADER_ACTION_TEXT]: '#512C01',
//   [TOKENS.NAVBAR_COLOR_TEXT]: '#512C01',
// }
const LIGHT_PINK = {
  label: '浅粉色',
  value: THEME_COLOR_KEYS.LIGHT_PINK,
  url: BASE_URL + THEME_COLOR_KEYS.LIGHT_PINK + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.LIGHT_PINK + GUIDE_BG,
  mode: THEME_MODE_KEYS.LIGHT,
  [TOKENS.COLOR]: '#F0519B',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#FFF6FB',
  [TOKENS.HEADER_GRADIENT_BG]: ['#FFE2F2', '#FFE2F2'],
  [TOKENS.SIDEBAR_BG]: '#FFFAFD',
  [TOKENS.CONTENT_BG]: '#FFFAFD',
  [TOKENS.HEADER_BG_IMAGE]: '',
  [TOKENS.HEADER_ACTION_TEXT]: '#5805233',
  [TOKENS.NAVBAR_COLOR_TEXT]: '#5805233',
}

// 基本配置-深色
const DARK_PURPLE_DEFAULT = {
  label: '默认',
  value: THEME_COLOR_KEYS.DARK_PURPLE_DEFAULT,
  url: BASE_URL + THEME_COLOR_KEYS.DARK_PURPLE_DEFAULT + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.DARK_PURPLE_DEFAULT + GUIDE_BG,
  mode: THEME_MODE_KEYS.DARK,
  [TOKENS.COLOR]: '#6D2EF8',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#6D2EF8',
  [TOKENS.HEADER_GRADIENT_BG]: ['#7639FF', '#A183FF'],
  [TOKENS.SIDEBAR_BG]: '#F8F9FF',
  [TOKENS.CONTENT_BG]: '#F8F9FF',
  [TOKENS.HEADER_BG_IMAGE]: '',
}

// const DARK_PURPLE = {
//   label: '紫晶色',
//   value: THEME_COLOR_KEYS.DARK_PURPLE,
//   url: BASE_URL + THEME_COLOR_KEYS.DARK_PURPLE + THEME_CARD_BG, // 主题设置小方块背景图片
//   guideUrl: BASE_URL + THEME_COLOR_KEYS.DARK_PURPLE + GUIDE_BG,
//   mode: THEME_MODE_KEYS.DARK,
//   [TOKENS.COLOR]: '#7658C7',
//   [TOKENS.COLOR_TEXT]: '#1D1C23',
//   [TOKENS.HEADER_BG]: '#7658C7',
//   [TOKENS.HEADER_GRADIENT_BG]: '#5E44A8',
//   [TOKENS.SIDEBAR_BG]: '#EDECFF',
//   [TOKENS.CONTENT_BG]: '#EDECFF',
//   [TOKENS.HEADER_BG_IMAGE]: '',
// }

// const DARK_ADZUKI_PURPLE = {
//   label: '豆沙紫色',
//   value: THEME_COLOR_KEYS.DARK_ADZUKI_PURPLE,
//   url: BASE_URL + THEME_COLOR_KEYS.DARK_ADZUKI_PURPLE + THEME_CARD_BG, // 主题设置小方块背景图片
//   guideUrl: BASE_URL + THEME_COLOR_KEYS.DARK_ADZUKI_PURPLE + GUIDE_BG,
//   mode: THEME_MODE_KEYS.DARK,
//   [TOKENS.COLOR]: '#674D60',
//   [TOKENS.COLOR_TEXT]: '#1D1C23',
//   // [TOKENS.HEADER_BG]: '#674D60',
//   [TOKENS.HEADER_GRADIENT_BG]: ['#956889', '#A47C99'],
//   [TOKENS.SIDEBAR_BG]: '#FFFAFE',
//   [TOKENS.CONTENT_BG]: '#FFFAFE',
//   [TOKENS.HEADER_BG_IMAGE]: '',
// }

const DARK_BLUE = {
  label: '商务蓝色',
  value: THEME_COLOR_KEYS.DARK_BLUE,
  url: BASE_URL + THEME_COLOR_KEYS.DARK_BLUE + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.DARK_BLUE + GUIDE_BG,
  mode: THEME_MODE_KEYS.DARK,
  [TOKENS.COLOR]: '#3F66EF',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#3A5CCC',
  [TOKENS.HEADER_GRADIENT_BG]: ['#466CE9', '#7A98FC'],
  [TOKENS.SIDEBAR_BG]: '#FAFBFF',
  [TOKENS.CONTENT_BG]: '#FAFBFF',
  [TOKENS.HEADER_BG_IMAGE]: '',
}

const DARK_GREEN = {
  label: '青绿色',
  value: THEME_COLOR_KEYS.DARK_GREEN,
  url: BASE_URL + THEME_COLOR_KEYS.DARK_GREEN + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.DARK_GREEN + GUIDE_BG,
  mode: THEME_MODE_KEYS.DARK,
  [TOKENS.COLOR]: '#507668',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#507668',
  [TOKENS.HEADER_GRADIENT_BG]: ['#649E89', '#7bAA98'],
  [TOKENS.SIDEBAR_BG]: '#F0F7F4',
  [TOKENS.CONTENT_BG]: '#F0F7F4',
  [TOKENS.HEADER_BG_IMAGE]: '',
}

// const DARK_OLIVE_GREEN = {
//   label: '橄榄绿色',
//   value: THEME_COLOR_KEYS.DARK_OLIVE_GREEN,
//   url: BASE_URL + THEME_COLOR_KEYS.DARK_OLIVE_GREEN + THEME_CARD_BG, // 主题设置小方块背景图片
//   guideUrl: BASE_URL + THEME_COLOR_KEYS.DARK_OLIVE_GREEN + GUIDE_BG,
//   mode: THEME_MODE_KEYS.DARK,
//   [TOKENS.COLOR]: '#556646',
//   [TOKENS.COLOR_TEXT]: '#1D1C23',
//   [TOKENS.HEADER_BG]: '#556646',
//   [TOKENS.HEADER_GRADIENT_BG]: '#3F4E35',
//   [TOKENS.SIDEBAR_BG]: '#E3EADC',
//   [TOKENS.CONTENT_BG]: '#E3EADC',
//   [TOKENS.HEADER_BG_IMAGE]: '',
// }

// const DARK_BROWN = {
//   label: '莫兰迪棕色',
//   value: THEME_COLOR_KEYS.DARK_BROWN,
//   url: BASE_URL + THEME_COLOR_KEYS.DARK_BROWN + THEME_CARD_BG, // 主题设置小方块背景图片
//   guideUrl: BASE_URL + THEME_COLOR_KEYS.DARK_BROWN + GUIDE_BG,
//   mode: THEME_MODE_KEYS.DARK,
//   [TOKENS.COLOR]: '#6B5C50',
//   [TOKENS.COLOR_TEXT]: '#1D1C23',
//   [TOKENS.HEADER_BG]: '#6B5C50',
//   [TOKENS.HEADER_GRADIENT_BG]: '#52463D',
//   [TOKENS.SIDEBAR_BG]: '#F0EEEB',
//   [TOKENS.CONTENT_BG]: '#F0EEEB',
//   [TOKENS.HEADER_BG_IMAGE]: '',
// }

const DARK_PINK = {
  label: '灰玫瑰色',
  value: THEME_COLOR_KEYS.DARK_PINK,
  url: BASE_URL + THEME_COLOR_KEYS.DARK_PINK + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.DARK_PINK + GUIDE_BG,
  mode: THEME_MODE_KEYS.DARK,
  [TOKENS.COLOR]: '#E64E92',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#E64E92',
  [TOKENS.HEADER_GRADIENT_BG]: ['#E178A8', '#F093bD'],
  [TOKENS.SIDEBAR_BG]: '#FFFAFC',
  [TOKENS.CONTENT_BG]: '#FFFAFC',
  [TOKENS.HEADER_BG_IMAGE]: '',
}

const DARK_GRAY = {
  label: '大理石灰色',
  value: THEME_COLOR_KEYS.DARK_GRAY,
  url: BASE_URL + THEME_COLOR_KEYS.DARK_GRAY + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.DARK_GRAY + GUIDE_BG,
  mode: THEME_MODE_KEYS.DARK,
  [TOKENS.COLOR]: '#4B4C6D',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  [TOKENS.HEADER_BG]: '#525A73',
  [TOKENS.HEADER_GRADIENT_BG]: ['#505175', '#505175'],
  [TOKENS.SIDEBAR_BG]: '#FAFCFF',
  [TOKENS.CONTENT_BG]: '#FAFCFF',
  [TOKENS.HEADER_BG_IMAGE]: '',
}


// 基本配置-氛围
const ATMOSPHERE_SPRING = {
  label: '春天',
  value: THEME_COLOR_KEYS.ATMOSPHERE_SPRING,
  url: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_SPRING + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_SPRING + GUIDE_BG,
  mode: THEME_MODE_KEYS.ATMOSPHERE,
  [TOKENS.COLOR]: '#007E6F',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#F1F6EE',
  [TOKENS.HEADER_GRADIENT_BG]: ['#C5ECE3', '#C5ECE3'],
  [TOKENS.SIDEBAR_BG]: '#F2F7F5',
  [TOKENS.CONTENT_BG]: '#F2F7F5',
  [TOKENS.HEADER_BG_IMAGE]: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_SPRING + THEME_HEADER_BG,
  [TOKENS.HEADER_ACTION_TEXT]: '#053d30',
  [TOKENS.NAVBAR_COLOR_TEXT]: '#053d30',
}
const ATMOSPHERE_SUMMER = {
  label: '夏天',
  value: THEME_COLOR_KEYS.ATMOSPHERE_SUMMER,
  url: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_SUMMER + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_SUMMER + GUIDE_BG,
  mode: THEME_MODE_KEYS.ATMOSPHERE,
  [TOKENS.COLOR]: '#1E4BEC',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#BCE7FF',
  [TOKENS.HEADER_GRADIENT_BG]: ['#AFE2FF', '#AFE2FF'],
  [TOKENS.SIDEBAR_BG]: '#F7FCFF',
  [TOKENS.CONTENT_BG]: '#F7FCFF',
  [TOKENS.HEADER_BG_IMAGE]: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_SUMMER + THEME_HEADER_BG,
  [TOKENS.HEADER_ACTION_TEXT]: '#073F75',
  [TOKENS.NAVBAR_COLOR_TEXT]: '#073F75',
}
const ATMOSPHERE_AUTUMN = {
  label: '秋天',
  value: THEME_COLOR_KEYS.ATMOSPHERE_AUTUMN,
  url: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_AUTUMN + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_AUTUMN + GUIDE_BG,
  mode: THEME_MODE_KEYS.ATMOSPHERE,
  [TOKENS.COLOR]: '#D97757',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#F7F5F2',
  [TOKENS.HEADER_GRADIENT_BG]: ['#F8E7D3', '#F8E7D3'],
  [TOKENS.SIDEBAR_BG]: '#F7F5F2',
  [TOKENS.CONTENT_BG]: '#F7F5F2',
  [TOKENS.HEADER_BG_IMAGE]: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_AUTUMN + THEME_HEADER_BG,
  [TOKENS.HEADER_ACTION_TEXT]: '#512C01',
  [TOKENS.NAVBAR_COLOR_TEXT]: '#512C01',
}
const ATMOSPHERE_WINTER = {
  label: '冬天',
  value: THEME_COLOR_KEYS.ATMOSPHERE_WINTER,
  url: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_WINTER + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_WINTER + GUIDE_BG,
  mode: THEME_MODE_KEYS.ATMOSPHERE,
  [TOKENS.COLOR]: '#236AF2',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#F1F7FE',
  [TOKENS.HEADER_GRADIENT_BG]: ['#C0D6FF', '#DFEAFF'],
  [TOKENS.SIDEBAR_BG]: '#FAFCFF',
  [TOKENS.CONTENT_BG]: '#FAFCFF',
  [TOKENS.HEADER_BG_IMAGE]: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_WINTER + THEME_HEADER_BG,
  [TOKENS.HEADER_ACTION_TEXT]: '#002566',
  [TOKENS.NAVBAR_COLOR_TEXT]: '#002566',
}
const ATMOSPHERE_PURPLE = {
  label: '铸剑',
  value: THEME_COLOR_KEYS.ATMOSPHERE_PURPLE,
  url: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_PURPLE + THEME_CARD_BG, // 主题设置小方块背景图片
  guideUrl: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_PURPLE + GUIDE_BG,
  mode: THEME_MODE_KEYS.ATMOSPHERE,
  [TOKENS.COLOR]: '#6D2EF8',
  [TOKENS.COLOR_TEXT]: '#1D1C23',
  // [TOKENS.HEADER_BG]: '#6D2EF8',
  [TOKENS.HEADER_GRADIENT_BG]: ['#7639FF', '#A183FF'],
  [TOKENS.SIDEBAR_BG]: '#F8F9FF',
  [TOKENS.CONTENT_BG]: '#F8F9FF',
  [TOKENS.HEADER_BG_IMAGE]: BASE_URL + THEME_COLOR_KEYS.ATMOSPHERE_PURPLE + THEME_HEADER_BG,
}

const createTheme = (theme) => {
  let gradientBg = theme[TOKENS.HEADER_GRADIENT_BG]
  if (!Array.isArray(gradientBg)) {
    gradientBg = ['transparent', 'transparent']
  }
  gradientBg = `linear-gradient(180deg, ${gradientBg[0]} 0%, ${gradientBg[1]} 100%)`

  return {
    [TOKENS.COLOR]: theme[TOKENS.COLOR],
    [TOKENS.COLOR_TEXT]: theme[TOKENS.COLOR_TEXT],
    [TOKENS.PLACEHOLDER_COLOR]: hexToRgba(theme[TOKENS.COLOR_TEXT], 0.5),
    [TOKENS.CONTENT_BG]: theme[TOKENS.CONTENT_BG],
    [TOKENS.DIVIDER]: hexToRgba(theme[TOKENS.COLOR_TEXT], 0.35),
    [TOKENS.LOGO_COLOR]: theme[TOKENS.COLOR],
    [TOKENS.LOGO_GRAY_COLOR]: theme[TOKENS.COLOR],
    [TOKENS.SIDEBAR_BG]: theme[TOKENS.SIDEBAR_BG],
    [TOKENS.SIDEBAR_DIVIDER]: hexToRgba(theme[TOKENS.COLOR], 0.06),
    [TOKENS.SIDEBAR_COLOR_TEXT_LAST]: hexToRgba(theme[TOKENS.COLOR_TEXT], 0.8),
    [TOKENS.SIDEBAR_COLOR_TEXT_ACTIVE]: theme[TOKENS.COLOR],
    [TOKENS.SIDEBAR_ICON_COLOR]: hexToRgba(theme[TOKENS.COLOR_TEXT], 0.5),
    [TOKENS.SIDEBAR_BG_HOVER]: hexToRgba(theme[TOKENS.COLOR], 0.06),
    [TOKENS.SIDEBAR_BG_ACTIVE]: hexToRgba(theme[TOKENS.COLOR], 0.1),
    [TOKENS.SIDEBAR_EXPAND_BG]: hexToRgba(theme[TOKENS.COLOR], 0.08),
    [TOKENS.SIDEBAR_COLLAPSE_BG_ACTIVE]: hexToRgba(theme[TOKENS.COLOR], 0.1),
    [TOKENS.SIDEBAR_COLLAPSE_BG_HOVER]: hexToRgba(theme[TOKENS.COLOR], 0.06),
    [TOKENS.NAVBAR_BG]: theme[TOKENS.HEADER_BG],
    [TOKENS.NAVBAR_COLOR_TEXT]: theme[TOKENS.NAVBAR_COLOR_TEXT],
    [TOKENS.NAVBAR_ICON_COLOR]: theme[TOKENS.COLOR_TEXT],
    [TOKENS.NAVBAR_ICON_BG]: hexToRgba(theme[TOKENS.COLOR], 0.1),
    [TOKENS.NAVBAR_BG_HOVER]: hexToRgba(theme[TOKENS.CONTENT_BG], 0.6),
    [TOKENS.NAVBAR_BG_ACTIVE]: theme[TOKENS.CONTENT_BG],
    [TOKENS.HEADER_BG]: theme[TOKENS.HEADER_BG],
    [TOKENS.HEADER_GRADIENT_BG]: gradientBg,
    [TOKENS.HEADER_BG_IMAGE]: theme[TOKENS.HEADER_BG_IMAGE],
    [TOKENS.HEADER_ACTION_TEXT]: theme[TOKENS.HEADER_ACTION_TEXT],
    [TOKENS.HEADER_ACTION_TEXT_HOVER]: theme[TOKENS.COLOR],
    [TOKENS.HEADER_ACTION_BG]: hexToRgba(WHITE_COLOR, 0.5),
    [TOKENS.HEADER_ACTION_BG_HOVER]: hexToRgba(WHITE_COLOR, 0.7),
    [TOKENS.SEARCH_BG]: hexToRgba(WHITE_COLOR, 0.7),
    [TOKENS.SEARCH_BORDER]: hexToRgba(theme[TOKENS.COLOR_TEXT], 0.1),
    [TOKENS.SEARCH_BORDER_FOCUS]: theme[TOKENS.COLOR],
    [TOKENS.MENU_ICON_BG_HOVER]: hexToRgba(theme[TOKENS.COLOR], 0.06),
  }
}

const createDarkTheme = (theme) => {
  let gradientBg = theme[TOKENS.HEADER_GRADIENT_BG]
  if (!Array.isArray(gradientBg)) {
    gradientBg = ['transparent', 'transparent']
  }
  gradientBg = `linear-gradient(180deg, ${gradientBg[0]} 0%, ${gradientBg[1]} 100%)`

  let sidebarExpandBg = hexToRgba(theme[TOKENS.COLOR], 0.08)
  let sidebarBg = hexToRgba(theme[TOKENS.COLOR], 0.1)
  if (theme.value === THEME_COLOR_KEYS.DARK_PURPLE_DEFAULT) {
    sidebarExpandBg = '#F0F2FF'
    sidebarBg = '#E2E3FF'
  }

  return {
    [TOKENS.COLOR]: theme[TOKENS.COLOR],
    [TOKENS.COLOR_TEXT]: theme[TOKENS.COLOR_TEXT],
    [TOKENS.PLACEHOLDER_COLOR]: hexToRgba(theme[TOKENS.COLOR_TEXT], 0.5),
    [TOKENS.PLACEHOLDER_DARK_COLOR]: hexToRgba(WHITE_COLOR, 0.5),
    [TOKENS.CONTENT_BG]: theme[TOKENS.CONTENT_BG],
    [TOKENS.DIVIDER]: hexToRgba(WHITE_COLOR, 0.35),
    [TOKENS.LOGO_COLOR]: WHITE_COLOR,
    [TOKENS.LOGO_GRAY_COLOR]: WHITE_COLOR,
    [TOKENS.SIDEBAR_BG]: theme[TOKENS.SIDEBAR_BG],
    [TOKENS.SIDEBAR_DIVIDER]: hexToRgba(theme[TOKENS.COLOR_TEXT], 0.06),
    [TOKENS.SIDEBAR_COLOR_TEXT_LAST]: theme[TOKENS.COLOR_TEXT],
    [TOKENS.SIDEBAR_COLOR_TEXT_ACTIVE]: theme[TOKENS.COLOR],
    [TOKENS.SIDEBAR_ICON_COLOR]: hexToRgba(theme[TOKENS.COLOR_TEXT], 0.5),
    [TOKENS.SIDEBAR_BG_HOVER]: sidebarBg,
    [TOKENS.SIDEBAR_BG_ACTIVE]: sidebarBg,
    [TOKENS.SIDEBAR_EXPAND_BG]: sidebarExpandBg,
    [TOKENS.SIDEBAR_COLLAPSE_BG_ACTIVE]: hexToRgba(theme[TOKENS.COLOR], 0.1),
    [TOKENS.SIDEBAR_COLLAPSE_BG_HOVER]: hexToRgba(theme[TOKENS.COLOR], 0.06),
    [TOKENS.NAVBAR_BG]: theme[TOKENS.HEADER_BG],
    [TOKENS.NAVBAR_COLOR_TEXT]: WHITE_COLOR,
    [TOKENS.NAVBAR_ICON_COLOR]: WHITE_COLOR,
    [TOKENS.NAVBAR_ICON_BG]: hexToRgba(theme[TOKENS.COLOR], 0.1),
    [TOKENS.NAVBAR_BG_HOVER]: hexToRgba(theme[TOKENS.CONTENT_BG], 0.15),
    [TOKENS.NAVBAR_BG_ACTIVE]: theme[TOKENS.CONTENT_BG],
    [TOKENS.HEADER_BG]: theme[TOKENS.HEADER_BG],
    [TOKENS.HEADER_GRADIENT_BG]: gradientBg,
    [TOKENS.HEADER_BG_IMAGE]: theme[TOKENS.HEADER_BG_IMAGE] || '',
    [TOKENS.HEADER_ACTION_TEXT]: WHITE_COLOR,
    [TOKENS.HEADER_ACTION_TEXT_HOVER]: hexToRgba(WHITE_COLOR, 0.8),
    [TOKENS.HEADER_ACTION_BG]: hexToRgba(WHITE_COLOR, 0.2),
    [TOKENS.HEADER_ACTION_BG_HOVER]: hexToRgba(WHITE_COLOR, 0.4),
    [TOKENS.SEARCH_BG]: WHITE_COLOR,
    [TOKENS.SEARCH_BORDER]: hexToRgba(theme[TOKENS.COLOR_TEXT], 0.15),
    [TOKENS.SEARCH_BORDER_FOCUS]: theme[TOKENS.COLOR],
    [TOKENS.SIDEBAR_ICON_BG_HOVER]: hexToRgba(theme[TOKENS.COLOR], 0.06)
  }
}

// 默认主题模式
export const THEME_MODE = [
  {
    value: THEME_MODE_KEYS.DARK,
    label: '深色'
  },
  {
    value: THEME_MODE_KEYS.LIGHT,
    label: '浅色'
  },
  {
    value: THEME_MODE_KEYS.ATMOSPHERE,
    label: '氛围'
  }
]

// 引导页配置
export const GUIDE_THEMES = [
  // 浅色主题
  // { ...LIGHT_PURPLE_DEFAULT },
  { ...LIGHT_PURPLE },
  { ...LIGHT_ICE_BLUE },
  { ...LIGHT_BLUE },
  // { ...LINGT_GREEN },
  { ...LIGHT_EYE_GREEN },
  // { ...LIGHT_EYE_YELLOW },
  { ...LIGHT_PINK },
  // 深色主题
  { ...DARK_PURPLE_DEFAULT },
  // { ...DARK_PURPLE },
  // { ...DARK_ADZUKI_PURPLE },
  { ...DARK_BLUE },
  { ...DARK_GREEN },
  // { ...DARK_OLIVE_GREEN },
  // { ...DARK_BROWN },
  { ...DARK_PINK },
  { ...DARK_GRAY },
  // 氛围主题
  { ...ATMOSPHERE_PURPLE },
  { ...ATMOSPHERE_SPRING },
  { ...ATMOSPHERE_SUMMER },
  { ...ATMOSPHERE_AUTUMN },
  { ...ATMOSPHERE_WINTER },
]

// 内置主题
export const BUILTIN_THEMES = GUIDE_THEMES.map(theme => {
  let tokens = theme.mode === THEME_MODE_KEYS.DARK ? createDarkTheme(theme) : createTheme(theme)
  if (theme.value === THEME_COLOR_KEYS.ATMOSPHERE_PURPLE) {
    tokens = createDarkTheme(theme)
  }
  return {
    ...theme,
    tokens
  }
})

export const LOG_PREFIX = '[系统配置]：'

// 对比度配置
export const CONTRAST_CONFIG = [1, 1.5, 2, 2.5, 3]

export const SAVE_CONFIG = {
  ID: 'id',
  EMPLOYEE_ID: 'employeeId', // 员工ID
  SKIN_ID: 'skinsCode', // 皮肤ID
  CONTRAST: 'contrast', // 对比度
  SHOW_DIGITAL_HUMAN: 'displayDigitalHumanFlag', // 是否显示数字人
  UPDATE_TIME: 'updationDate', // 更新时间戳
  CREATE_TIME: 'creationDate', // 创建时间戳
}

export const DEFAULT_CONFIG = {
  // [SAVE_CONFIG.IS_SAVE]: false,
  [SAVE_CONFIG.EMPLOYEE_ID]: '',
  [SAVE_CONFIG.SHOW_DIGITAL_HUMAN]: 1, // 是否显示数字人
  [SAVE_CONFIG.SKIN_ID]: THEME_COLOR_KEYS.DARK_PURPLE_DEFAULT, // 皮肤ID
  [SAVE_CONFIG.CONTRAST]: localStorage.svgFilter || 1, // 对比度
}

export const REPORT_CONFIG = {
  SKIN_FLAG: 'themeModifiedFlag', // 主题色操作标记，未变更也算操作
  CONTRAST_FLAG: 'contrastModifiedFlag', // 对比度操作标记，未变更也算操作
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/theme-system/config.js